// extracted by css-extract-rspack-plugin
export default {"lastUpdated":"lastUpdated-cPupxJ","refreshBtn":"refreshBtn-wUFchS","toast":"toast-VWbcNT","alert":"alert-KQQafj"};